import { render, staticRenderFns } from "./ConfiguracaoIndex.vue?vue&type=template&id=9cb4592a&"
import script from "./ConfiguracaoIndex.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports